import React, { useState } from 'react'
import logo from '../assets/logo.png';



export default function Menu() {

  const [show, setShow] = useState(false);


  return (

    <header className=''>

      <div className="lg:flex hidden items-center justify-between font-inter h-28">

        <a href="/" className="flex items-center gap-2 group">
          <img src={logo} alt="Logo" className='w-12' />
          <p className='font-semibold group-hover:text-blue-50'>GEMINI AI</p>
        </a>

        <nav>
          <ul className="text-md flex justify-center gap-16 items-center text-white-100 font-semibold">
            <li>
              <a href="https://www.dextools.io/app/en/ether/pair-explorer/0x056df6e15a7ce9dfd334c488737d9ffc2773582b" className="uppercase flex items-center gap-2 hover:text-blue-50 group">dextools
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="3.5" stroke="currentColor" className="w-4 h-4 group-hover:rotate-180 transition-all">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 4.5l15 15m0 0V8.25m0 11.25H8.25" />
                </svg>
              </a>
            </li>

            <li>
              <a href="https://dexscreener.com/ethereum/0x01D182420a501e29C31D41bBCC7a25A4200d1535" className="uppercase flex items-center gap-2 hover:text-blue-50 group">dexscreener
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="3.5" stroke="currentColor" className="w-4 h-4 group-hover:rotate-180 transition-all">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 4.5l15 15m0 0V8.25m0 11.25H8.25" />
                </svg>
              </a>
            </li>

            <li>
              <a href="https://x.com/geminiai_erc?s=21&t=AAeulnrJ8097JIfGWHF2cQ" className="uppercase flex items-center gap-2 hover:text-blue-50 group">twitter
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="3.5" stroke="currentColor" className="w-4 h-4 group-hover:rotate-180 transition-all">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 4.5l15 15m0 0V8.25m0 11.25H8.25" />
                </svg>
              </a>
            </li>

            <li className='border border-black-50 rounded-full px-8 py-4 hover:bg-blue-50 hover:text-black-100'><a href="https://t.me/GeminiAI_ERC" className="uppercase">Community</a>
            </li>
          </ul>
        </nav>
      </div>

      <div className="lg:hidden flex items-center justify-between py-5 font-inter">
        <a href="/" className="flex items-center gap-2 group">
          <img src={logo} alt="Logo" className='w-12' />
          <p className='font-semibold group-hover:text-blue-50'>GEMINI AI</p>
        </a>

        <button onClick={() => setShow(!show)} className="nav cursor-pointer">

          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 text-white-100">
            <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"></path>
          </svg>

        </button>
      </div>

      {
        show ? <div className="fixed top-0 left-0 bottom-0 z-40 p-2 w-3/4 overflow-y-auto text-center font-inter font-semibold bg-social">

          <a href="/" className="flex items-center gap-2 my-5">
            <img src={logo} alt="Logo" className='w-12' />
            <p className='font-semibold group-hover:text-blue-50 uppercase'>geminiAI</p>
          </a>

          <button onClick={() => setShow(!show)} className="w-full py-2.5 mt-12 flex items-center rounded-md shadow-md">
            <a href="https://www.dextools.io/app/en/ether/pair-explorer/0x056df6e15a7ce9dfd334c488737d9ffc2773582b" className="text-lg ml-4 font-semibold uppercase">DEXTOOLS</a>
          </button>

          <button onClick={() => setShow(!show)} className="w-full py-2.5 mt-5 flex items-center rounded-md transition shadow-md">
            <a href="https://dexscreener.com/ethereum/0x01D182420a501e29C31D41bBCC7a25A4200d1535" className="text-lg ml-4 font-semibold uppercase">dexscreener</a>
          </button>
          <button onClick={() => setShow(!show)} className="w-full py-2.5 mt-5 flex items-center rounded-md shadow-md">
            <a href="https://x.com/geminiai_erc?s=21&t=AAeulnrJ8097JIfGWHF2cQ" className="text-lg ml-4 font-semibold uppercase">twitter</a>
          </button>
          <button onClick={() => setShow(!show)} className="w-full py-2.5 mt-5 flex items-center rounded-md shadow-md">
            <a href="https://t.me/GeminiAI_ERC" className="text-lg ml-4 font-semibold uppercase">community</a>
          </button>
         
        </div> : null
      }


    </header >
  )
}
